import LauncherResourcesJson from './LauncherResourcesJson';

export default class LauncherResourcesBackend extends LauncherResourcesJson {
    static OPTIONS_URL = '/select-options';
    static FEATURES_URL = '/features';

    constructor(baseUrl) {
        super(
            LauncherResourcesBackend.getRequest(baseUrl, LauncherResourcesBackend.OPTIONS_URL),
            LauncherResourcesBackend.getRequest(baseUrl, LauncherResourcesBackend.FEATURES_URL)
        );
    }

    static getRequest(baseUrl, url) {
        if (!url.includes('://')) {
            url = `${baseUrl}${url}`
        }
        return fetch(url, {
              method: 'GET',
              headers: new Headers({
                'Content-Type': 'application/json'
              }),
            }).then(v => v.json())
    }
}
